import axios from 'axios';
import config from '@/config/constants.js';

export default {
    namespaced: true,
    state: {
        status: '',
        tenant_id: "",
        name_vendor: "",
        user: {},
        referral: "",
    },
    mutations: {
        referral(state, token) {
            state.referral = token;
        },
        loading(state) {
            state.status = 'loading';
        },
        status(state, status) {
            state.status = status;
        },
        tenant(state, id) {
            state.tenant_id = id;
        },
        nameVendor(state, name) {
            state.name_vendor = name;
        },
        success(state, user = null) {
            state.status = "";
            if (user) {
                state.user = user;
            }
        },
    },
    actions: {
        signup_employee: function ({commit, state}, data) {
            let params = data;
            params['no_owner'] = true;
            params['tenant_id'] = state.tenant_id;
            params['signup_for'] = "employee";
            // Forward the signed invite token so the backend can authorize the
            // activation (captured from the invite link in add_name_vendor).
            params['referral'] = state.referral;

            return new Promise(function (resolve, reject) {
                commit("loading");

                axios.post(config.api_url + 'users/me/activate', params)
                    .then(() => {
                        commit("success", data);
                        resolve(data);
                    })
                    .catch(err => {
                        commit("status", "error");
                        reject(err.response.data.message);
                    })
            });
        },
        add_employee: function ({commit, rootGetters}, users) {
            // eslint-disable-next-line no-async-promise-executor
            return new Promise(async function (resolve) {
                commit('loading');
                let errorsCounter = 0;
                for (let i in users) {
                    let user = users[i];
                    user.phone = user.phone_number
                        .replaceAll(' ', '')
                        .replaceAll('-', '');
                    user.phone = config.phone_extension + user.phone;
                    let user_to_save = {
                        owner_id: rootGetters['Authenticate/current_user'].phone_number,
                        first_name: user.first_name,
                        last_name: user.last_name,
                        email: user.email,
                        phone_number: user.phone,
                        is_admin: user.is_admin,
                    };

                    try {
                        await axios.post(config.api_url + 'add_employee', user_to_save);
                        user['error'] = '';
                    } catch (error) {
                        errorsCounter++;
                        user['error'] = error.response.data.message;
                    }
                }
                commit('success');
                resolve(errorsCounter);
            });
        },
        add_name_vendor: function ({commit}, token) {

            // eslint-disable-next-line no-async-promise-executor
            return new Promise(async function (resolve, reject) {
                commit('loading');
                let param = {
                    "referral": token,
                    "signup_for": "employee"
                }
                commit("referral", token);
                await axios.post(config.api_url + 'get_user', param)
                    .then(response => {
                        commit("nameVendor", response.data.name);
                        commit("tenant", response.data.tenant_id);
                        resolve(response);
                    })
                    .catch(err => {
                        reject(err.response.data.message);
                    })
                commit("success");
            });
        },
    },
    getters: {},
    modules: {},
};
